import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import Container from "@saleor/components/Container";
import LanguageSwitch from "@saleor/components/LanguageSwitch";
import PageHeader from "@saleor/components/PageHeader";
import { ProductLensTypeTranslationFragment } from "@saleor/fragments/types/ProductLensTypeTranslationFragment";
import { commonMessages, sectionNames } from "@saleor/intl";
import { TranslationsEntitiesPageProps } from "@saleor/translations/types";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { LanguageCodeEnum } from "../../../types/globalTypes";
import TranslationFields from "../TranslationFields";

export interface TranslationsProductLensTypePageProps
  extends TranslationsEntitiesPageProps {
  lensType: ProductLensTypeTranslationFragment;
}

export const fieldNames = {
  name: "name"
};

const TranslationsProductLensTypePage: React.FC<TranslationsProductLensTypePageProps> = ({
  activeField,
  disabled,
  languageCode,
  languages,
  lensType,
  saveButtonState,
  onBack,
  onDiscard,
  onEdit,
  onLanguageChange,
  onSubmit
}) => {
  const intl = useIntl();

  return (
    <Container>
      <AppHeader onBack={onBack}>
        {intl.formatMessage(sectionNames.translations)}
      </AppHeader>
      <PageHeader
        title={intl.formatMessage(
          {
            defaultMessage:
              'Translation Product Lens Type "{lensTypeName}" - {languageCode}',
            description: "header"
          },
          {
            languageCode,
            lensTypeName: maybe(() => lensType.name, "...")
          }
        )}
      >
        <LanguageSwitch
          currentLanguage={LanguageCodeEnum[languageCode]}
          languages={languages}
          onLanguageChange={onLanguageChange}
        />
      </PageHeader>
      <TranslationFields
        activeField={activeField}
        disabled={disabled}
        initialState={true}
        title={intl.formatMessage(commonMessages.generalInformations)}
        fields={[
          {
            displayName: intl.formatMessage({
              defaultMessage: "LensType Name"
            }),
            name: fieldNames.name,
            translation: maybe(() =>
              lensType.translation ? lensType.translation.name : null
            ),
            type: "short" as "short",
            value: maybe(() => lensType.name)
          }
        ]}
        saveButtonState={saveButtonState}
        onEdit={onEdit}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
      />
      <CardSpacer />
    </Container>
  );
};
TranslationsProductLensTypePage.displayName = "TranslationsProductLensTypePage";
export default TranslationsProductLensTypePage;
